import styled from 'styled-components';
import {header} from '../loginForm/LoginForm.css';
import {dFlexCenter} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div`
    padding: 0 35px 160px 35px; 
    ${dFlexCenter};
    align-items: start;
    flex-direction: column;
    height: 100%;
    width: 100%;
    transition: all 300ms;
    justify-content: space-between;
`;

export const title=styled(header)`
    font-size: 24px;
    font-weight: 700;
    margin: auto;
`;

export const inputs = styled.div`
    width: 100%;
    margin-top: 15px;
    gap: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const text = styled.div`
    font-size: 12px;
`;

export const details = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export const email = styled.div`
    font-size: 14px;
    font-weight: 800;
`;

export const enterButton = styled.div`
    margin-top: 50px;
    width: 100%;
`;